/**
 * The session "surface" role — what the app stores in localStorage
 * `user_role` and what BugReportModal writes as `reportedByRole`. Lives in
 * shared/ because the Claude connector's raise_bug_report must write the
 * same value the form would for the same person (functions can't import
 * src/lib/session.ts, and a hand-mirror is banned — see CLAUDE.md).
 */

/** Every `user_role` value AuthGuard accepts (useAuth.hasValidSession). */
export type SessionRole = 'office' | 'sales' | 'ops' | 'tech' | 'provisioning' | 'guest_tech';

/**
 * Map a Firestore `users.role` ('Admin', 'Tech', 'GuestTech', …) to the
 * session role AuthGuard accepts. Shared by the PIN/code path
 * (LandingPage) and the magic-link path (AuthVerifyPage) — the link path
 * used to lowercase the raw role, so an 'Admin' user stored 'admin',
 * failed hasValidSession, and was bounced to the login page a second
 * after signing in.
 */
export function sessionRoleForUserRole(userRole: string | null | undefined): SessionRole {
  switch (userRole) {
    case 'Tech':
      return 'tech';
    case 'GuestTech':
      return 'guest_tech';
    case 'Sales':
      return 'sales';
    case 'Ops':
      return 'ops';
    case 'Provisioning':
      return 'provisioning';
    case 'Admin':
    default:
      return 'office';
  }
}
